<script>
export default {
  methods: {
    GetOaRight(ModuleCode, PermissonList, token,axios,oarighturl) {
        var _this=this;
     
      var headers = { Authorization: token };
      var params = { ModuleCode: ModuleCode };
       axios.get(oarighturl, { params, headers }).then((res) => {
        if (res != null && res != "[]" && res.data.length > 0) {
          var data = res.data;
          for (var key in PermissonList) {
            for (var i = 0; i < data.length; i++) {
              if (data[i].PermissionCode == PermissonList[key].key) {
                PermissonList[key].value = true;
                break;
              }
            }
          }
        }
      })
    //  NewPermissonList=PermissonList
     return PermissonList;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Global.vue